import OperatorApplicationMessageSuggestedAnswerOpenApiModel = OperatorApplicationApi.OperatorApplicationMessageSuggestedAnswerOpenApiModel;

export interface OperatorApplicationDialogTextareaModelInterface {
    answerChannelId: string,
    replyTo?: {
        messageId: number,
        textPreview: string
    }
    text: string,
    botId: string;
    files: { id: string, name: string, size: number, url: string }[],
    knowledgeBase: OperatorApplicationDialogTextareaModelKnowledgeBaseInterface[],
    answerChannelSourceId: string,
    templateId: string,
    suggestedAnswerId: number
}

export const KnowledgeBaseEssenceArticle = "article";
export const KnowledgeBaseEssenceGroup = "group";


export type KnowledgeBaseEssence = typeof KnowledgeBaseEssenceArticle | typeof KnowledgeBaseEssenceGroup;

export interface OperatorApplicationDialogTextareaModelKnowledgeBaseInterface {
    essence: KnowledgeBaseEssence,
    id: string,
    registerId: string,
    descr: string
}

export const USE_OPERATOR_SUGGEST_EVENT = "useOperatorMessageSuggest";

export interface UseOperatorMessageSuggestEventPayloadInterface {
    username: string;
    suggest: OperatorApplicationMessageSuggestedAnswerOpenApiModel;
    send: boolean;
}